import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-alert-concluido',
    templateUrl: './alert-concluido.component.html',
    styleUrls: ['./alert-concluido.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertConcluidoComponent {

  @Input() alertConcluido: boolean = false;
  @Input() alertConcluidoTitulo: string;
  @Input() alertConcluidoMensagem: string;

  @Output() alertConcluidoFechou = new EventEmitter();

  constructor(public rota: Router) { }

  fecharAlertConcluido() {
    this.alertConcluidoFechou.emit('OK');
  }

}
